// ABOUTME: Shows products whose forecast was invalidated by a config save and is being
// ABOUTME: recomputed in the background, so they do not silently vanish from the schedule.

import React from 'react';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Divider,
  CircularProgress,
} from '@mui/material';
import { colors } from '../../theme/colors';

function PendingProductsSection({ products, onProductSelect }) {
  const { t } = useTranslation();

  if (!products || products.length === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        border: `1px solid ${colors.status.info}`,
        borderRadius: '12px',
        p: 2,
        backgroundColor: 'rgba(92, 225, 230, 0.08)',
      }}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <CircularProgress size={18} sx={{ color: colors.status.info }} />
        <Typography sx={{ fontWeight: 600, color: colors.text.primary }}>
          {t('dashboard.schedule.pending.title')} ({products.length})
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ color: colors.text.secondary }}>
        {t('dashboard.schedule.pending.subtitle')}
      </Typography>
      <List dense>
        {products.map((product, index, array) => (
          <React.Fragment key={`pending-${product.product_id}-${index}`}>
            <ListItem
              onClick={() => onProductSelect && onProductSelect(product.product_id)}
              sx={{ cursor: onProductSelect ? 'pointer' : 'default' }}
            >
              <ListItemIcon sx={{ minWidth: 32 }}>
                <CircularProgress size={14} sx={{ color: colors.status.info }} />
              </ListItemIcon>
              <ListItemText
                primary={
                  <Typography variant="subtitle2" sx={{ color: colors.text.primary }}>
                    {product.product_name}
                    <Typography
                      component="span"
                      variant="caption"
                      sx={{ ml: 1, fontWeight: 'normal', color: colors.text.secondary }}
                    >
                      ({product.product_id})
                    </Typography>
                  </Typography>
                }
                secondary={
                  product.current_stock != null ? (
                    <Typography variant="caption" sx={{ color: colors.text.secondary }}>
                      {t('dashboard.schedule.pending.stock')}: {product.current_stock}
                    </Typography>
                  ) : null
                }
              />
            </ListItem>
            {index < array.length - 1 && <Divider />}
          </React.Fragment>
        ))}
      </List>
    </Box>
  );
}

export default PendingProductsSection;
